















import {
  Vue,
  Component,
  Prop
} from "vue-property-decorator";

@Component({
  components: {},
})
export default class ListView extends Vue {
    @Prop()
    public leftValue!: string;
    @Prop()
    public data?: any;
    @Prop()
    public rightValue?: string
    @Prop()
    public icon?:string;
    @Prop()
    public type?: string;
    @Prop()
    public readState?:Boolean
    mounted(){
    }

    public setButtonClass (){
        let retClass = "list-right-button";
        if (this.type) retClass += ` ${this.type}`
        if(this.readState && this.data.readFlag) retClass+=' read'
        return retClass
    }
    public rightClick() {
        if(this.data) {
            this.$emit('rightClick',this.data)
        }
    }
}
